const React = require("react");
const T = React.PropTypes;

const Colorizer = require("../Colorizer");
const HistoricalFile = require("../types/HistoricalFile.js");

const HistoryFileEmblem = require("./HistoryFileEmblem.jsx");
const FileInfoBox = require("./FileInfoBox");

const styles = {
    Outer: {
        textAlign: "left",
        backgroundColor: "#e8e8e8",
        boxShadow: "0px 2px 3px #bbb",
    },
    Icon: {
        paddingRight: 20,
        fontSize: 22
    },
    List: {
        height: "100%",
        padding: 0,
        paddingLeft: 5,
        listStyle: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "left",
    },
    Item: {
        padding: "10px 0 10px 10px"
    }
};

const DateFormat = "ddd M/D/YYYY h:mm A";

const HistoryItem = React.createClass({
    propTypes: {
        style: T.object,
        File: HistoricalFile.Type.isRequired
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const style = Object.assign({}, this.props.style, styles.Outer);

        const file = this.props.File;

        const iconColor = Colorizer.ForNumber(file.UploadTypeID);

        const iconStyle = Object.assign({
            color: iconColor
        }, styles.Icon);
                
        const completed = this.props.File.Completed;
        const errored = this.props.File.Errored;
        
        const emblemStyle = {
            color: iconColor
        };

        const emblemNode = (<div>
            <HistoryFileEmblem HistoricalFile={file}
                               IconStyle={emblemStyle} />
        </div>);

        var status = "Still processing...";

        if (completed) {
            status = errored ? `An error occurred and this file was not processsed, please try again. If the error continues, please contact IT Support.`
                             : `Completed ${completed.format(DateFormat)}`;
        }
        
        const infoNode = (<ul style={styles.List}>
            <li style={styles.Item }>{file.UploadTypeName}</li>
            <li style={styles.Item }>Started {file.Started.format(DateFormat)}</li>
            <li style={styles.Item}>{status}</li>
        </ul>);

        return (<FileInfoBox style={this.props.style}
                        FileNode={emblemNode}
                        InfoNode={infoNode} />);
    }
});

module.exports = HistoryItem;


// WEBPACK FOOTER //
// ./src/components/HistoryItem.jsx